import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CheckboxGroupComponent} from "./checkbox-group.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [CheckboxGroupComponent],
  imports: [ CommonModule, TranslateModule ],
  exports: [ CheckboxGroupComponent ],
})
export class CheckboxGroupModule {}
